export const EVENT_SURVEY = 'survey';
export const EVENT_SURVEY_QUESTION = 'event_survey';
export const SESSION_FEEDBACK = 'session_feedback';
export const LIVE_POLL = 'live_poll';

export const SESSIONS_ALL = 'all_sessions';
export const SESSIONS_SELECTED = 'selected_sessions';
export const TRACKS = 'selected_tracks';
